import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight, BookOpen } from "lucide-react";

export default function Services() {
  return (
    <div className="mx-auto max-w-5xl px-5 py-16 lg:px-8">
      <span className="label-caps text-primary">Services</span>
      <h1 className="mt-2 font-head text-4xl font-black sm:text-5xl">Our Services</h1>
      <p className="mt-3 max-w-2xl text-muted-foreground">Choose the support your family needs. Each service is separate — use one, the other, or both.</p>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        <Link to="/cover-school" data-testid="service-cover-school" className="group border border-border bg-card p-8 transition-all hover:-translate-y-1 hover:border-primary hover:shadow-brutal">
          <span className="flex h-12 w-12 items-center justify-center border border-primary bg-primary/10 text-primary"><ShieldCheck className="h-6 w-6" strokeWidth={2.25} /></span>
          <h2 className="mt-5 font-head text-2xl font-bold group-hover:text-primary">Cover School Enrollment</h2>
          <p className="mt-2 text-sm text-muted-foreground">Alabama church-school legal cover for your homeschool. Instant enrollment documents. $113/year per family. <strong>Alabama only.</strong></p>
          <span className="mt-5 inline-flex items-center gap-2 label-caps text-primary">Learn More <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
        </Link>

        <Link to="/curriculum" data-testid="service-curriculum" className="group border border-border bg-card p-8 transition-all hover:-translate-y-1 hover:border-primary hover:shadow-brutal">
          <span className="flex h-12 w-12 items-center justify-center border border-primary bg-primary/10 text-primary"><BookOpen className="h-6 w-6" strokeWidth={2.25} /></span>
          <h2 className="mt-5 font-head text-2xl font-bold group-hover:text-primary">K–12 Online Curriculum</h2>
          <p className="mt-2 text-sm text-muted-foreground">Complete lessons, auto-graded quizzes, workbooks, and an AI tutor. Open to families anywhere.</p>
          <span className="mt-5 inline-flex items-center gap-2 label-caps text-primary">Explore Curriculum <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
        </Link>
      </div>
    </div>
  );
}
